<ion-item lines="none" class="transparent" *ngIf="message">
  <ion-label color="danger">{{message}}</ion-label>
</ion-item>
<ion-button *ngIf="message && mayUpdate && !error" (click)="updateApp()">
  <ion-label>{{'UpdateApp' | translate}}</ion-label>
</ion-button>
